import b1 from "../assets/b1.png";
import b3 from "../assets/b3.png";

export const BANKING_SYLLABUS_DATA = [
 {
  id: "bank-ibps-1",
  title: "IBPS Banking Exam – Complete Training Program",
  hours: "300+ hrs",
  image: b1,
  modules: [
   "Structured preparation for government bank exams",
   "Covers major exams like SBI, IBPS, and RRB",
   "Experienced faculty and exam-focused training",
   "Regular practice tests and exam strategies",
   "Interview guidance and preparation",
   "Placement assistance support",
   "Logical Reasoning",
   "Quantitative Aptitude",
   "General English",
   "General Awareness",
   "Financial Awareness",
   "Exams Covered:",
   "SBI PO / SO",

"IBPS PO / SO",

"RRB Exams",

"Bank Clerk Exams"
  ],
  outcomes: [
    "Build strong fundamentals required for IBPS, SBI, and RRB banking exams",
    "Improve problem-solving speed and accuracy across all exam sections",
    "Gain complete section-wise and full-length exam readiness",
    "Develop confidence to handle prelims and mains examinations",
    "Stay updated with banking, financial, and current affairs knowledge",
    "Perform effectively in online banking examinations",
    "Increase chances of selection in government and public sector banks"
  ],
  idealFor: [
    "IBPS PO, Clerk, and RRB aspirants",
    "SBI PO and SBI Clerk exam candidates",
    "Final-year college students",
    "Graduates preparing for government bank exams",
    "Job seekers aiming for stable banking careers",
    "Candidates preparing for insurance and financial sector exams"
  ]
},

  {
  id: "bank-private-bfsi-1",
  title: "Private Banking",
  hours: "Industry-oriented",
  image: b3,
  modules: [
    "Banking Fundamentals",
    "Retail Banking",
    "Loans & Credit Processing",
    "Digital Banking & Payment Systems",
    "Customer Relationship Management",
    "Third Party Banking Products",
    "Professional & Interview Skills",
    "Industry-aligned banking curriculum",
    "Practical training in banking operations",
    "Learn from experienced trainers",
    "Career-focused BFSI training",
    "Interview preparation & soft skills training",
    "400+ students trained and placed in banking sectors",

    "Kickstart your career in the Banking and Financial Services Industry (BFSI) with our industry-focused training program.",
    "This course provides practical knowledge of banking operations, retail banking, loan processing, payment systems, and customer relationship management, preparing you for roles in private banks and financial institutions.",
    "More than 400+ students have already been trained and placed in private banking and finance sectors by our expert trainers."
  ],
  outcomes: [
    "Gain practical understanding of private banking and BFSI operations",
    "Understand real-world banking workflows and branch-level activities",
    "Handle customer onboarding, servicing, and relationship management",
    "Develop working knowledge of retail banking products and services",
    "Understand loan processing, documentation, and payment systems",
    "Build confidence for customer-facing and operational banking roles",
    "Prepare for entry-level and executive roles in private banks",
    "Develop industry-ready skills aligned with private banking jobs"
  ],
  idealFor: [
    "Kickstart your career in the Banking and Financial Services Industry (BFSI) with our industry-focused training program.",
    "This course provides practical knowledge of banking operations, retail banking, loan processing, payment systems, and customer relationship management, preparing you for roles in private banks and financial institutions.",
    "More than 400+ students have already been trained and placed in private banking and finance sectors by our expert trainers."
  ]
},

];
